import { WsEvent } from '@ts-ws/enums'

import { useDisciplineStore } from '@stores/discipline'

import { useActiveDisciplineInfoApi } from '@api/disciplines/active-discipline-info.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

export const useListenEventDiscipline = (channel: any): void => {
  const disciplineStore = useDisciplineStore()

  onDisciplineReady(() => {
    channel.listen(WsEvent.DisciplineUpdated, async (event: any): Promise<void> => {
      if (disciplineStore.getInfoStatus(event.id) === 'idle') return

      void useActiveDisciplineInfoApi({ disciplineId: event.id, mode: 'refresh' })
    })
  })
}
